import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import './SoftwareHero.css';

const SoftwareHero = () => {
  return (
    <Box className="software-hero">
      <div className="software-hero-overlay" />
      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <motion.div
          className="software-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="subtitle1"
            className="software-hero-subtitle-top"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Our Services
          </Typography>
          <Typography
            variant="h1"
            className="software-hero-title"
            component={motion.h1}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            SOFTWARE DEVELOPMENT
          </Typography>
          <Typography
            className="software-hero-description"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Transform your business with our cutting-edge software development solutions. 
            We craft scalable, secure, and innovative applications that drive growth and 
            efficiency. Our expert team delivers tailored solutions that align perfectly 
            with your business objectives.
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default SoftwareHero; 